<template>
  <el-popover
    trigger="focus"
    placement="top"
    :disabled="!hasTips"
    >
    <span
      style="display: block"
      v-for="(tip, tipIndex) in tips"
      v-html="tip"
      :key="tipIndex"></span>
    <el-input
      slot="reference"
      v-bind="props"
      :value="value"
      @input="onInput"
      @blur="onBlur">
      <span v-if="showWordLimit" slot="suffix" style="margin-right: 6px;">{{ inputLength }}/{{ props.maxLengthRule}}</span>
    </el-input>
  </el-popover>
</template>

<script>
import { checkLength } from '@/components/prod/center/components/TBInfoForm/utils/index'
export default {
  props: ["props", "value"],
  computed: {
    key() {
      return this.props.name
    },
    tips() {
      return this.props.tipRule || []
    },
    hasTips() {
      return this.tips.length
    },
    showWordLimit() {
      return this.props?.showSuffixLength && this.props?.maxLengthRule
    },
    inputLength() {
      return checkLength(this.value)
    }
  },
  methods: {
    onInput(v) {
      this.$emit('change', v)
    },
    onBlur() {
      this.$emit('blur', this.value)
    },
  },
}
</script>

<style></style>
